import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, rem, spacing, getResetByTag, utilityStyles } from '../../styles';
import StyledDropdownMenu from './styles/dropdown.menu.styles';
import StyledDropdownMenuBackground from './styles/dropdown.menu-background.styles';
import StyledDropdownIconContainer from './styles/dropdown.icon-container.styles';
import StyledDropdownMenuWrapper from './styles/dropdown.menu-wrapper.styles';
import StyledLoader from '../loader/loader.styles';
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "yqjhl6",
  styles: "display:flex;flex-direction:column;position:relative"
} : {
  name: "1v5tb95-dropDownDefaultStyles",
  styles: "display:flex;flex-direction:column;position:relative;label:dropDownDefaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var dropDownDefaultStyles = function dropDownDefaultStyles() {
  return _ref2;
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1n8met0",
  styles: "padding-top:0"
} : {
  name: "1hlioti-labelStyles",
  styles: "padding-top:0;label:labelStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var labelStyles = function labelStyles(_ref3) {
  var label = _ref3.label;
  if (!label) {
    return _ref;
  }
};
var sizeStyles = function sizeStyles(_ref4) {
  var size = _ref4.size;
  switch (size) {
    case 'sm':
      return /*#__PURE__*/css(StyledDropdownMenu, "{height:", rem(spacing.spacingControlHeightSm), ";padding-right:", rem(spacing.spacingControlHeightSm), ";&~", StyledDropdownMenuBackground, "{&>", StyledDropdownIconContainer, "{min-width:", rem(spacing.spacingControlHeightSm), ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css(StyledDropdownMenu, "{height:", rem(spacing.spacingControlHeightXl), ";padding-right:", rem(spacing.spacingControlHeightXl), ";&~", StyledDropdownMenuBackground, "{&>", StyledDropdownIconContainer, "{min-width:", rem(spacing.spacingControlHeightXl), ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:sizeStyles;"));
  }
};
var shapeStyles = function shapeStyles(_ref5) {
  var shape = _ref5.shape,
    size = _ref5.size;
  switch (shape) {
    case 'pill':
      return /*#__PURE__*/css(StyledDropdownMenu, ",", StyledDropdownMenuWrapper, ",", StyledDropdownMenuBackground, "{border-radius:", rem(((size === 'lg' ? spacing.spacingControlHeightXl : spacing.spacingControlHeightLg) - 2) / 2), ";}", StyledDropdownMenuBackground, "{&>", StyledDropdownIconContainer, "{background-color:", colors.transparent, ";border-bottom-right-radius:", rem(((size === 'lg' ? spacing.spacingControlHeightXl : spacing.spacingControlHeightLg) - 2) / 2), ";border-left:0;border-top-right-radius:", rem(((size === 'lg' ? spacing.spacingControlHeightXl : spacing.spacingControlHeightLg) - 2) / 2), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:shapeStyles;"));
    case 'square':
      return /*#__PURE__*/css(StyledDropdownMenu, "{border-left:0;border-radius:0;border-right:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:shapeStyles;"));
  }
};
var isLoadingStyles = function isLoadingStyles(_ref6) {
  var isLoading = _ref6.isLoading;
  if (isLoading) {
    return /*#__PURE__*/css(StyledLoader, "{left:50%;position:absolute;top:50%;transform:translate(-50%, -50%);svg{path{fill:", colors.navy_500, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:isLoadingStyles;"));
  }
};
var inlineStyle = function inlineStyle(_ref7) {
  var isBlock = _ref7.isBlock;
  if (!isBlock) return /*#__PURE__*/css(StyledDropdownMenuWrapper, "{display:inline-block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:inlineStyle;"));
};
var resetStyles = getResetByTag('div');
var StyledDropdown = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eo8pdr0"
} : {
  target: "eo8pdr0",
  label: "StyledDropdown"
})(resetStyles, dropDownDefaultStyles, labelStyles, sizeStyles, shapeStyles, isLoadingStyles, inlineStyle, utilityStyles);
export default StyledDropdown;